// extracted by mini-css-extract-plugin
export default {"header":"CP","container":"EP","accordeonitem":"FP","itemsticky":"GP","itemopen":"HP","open":"IP","productname":"JP","productinfo":"KP","flavorstext":"LP","invalidlimit":"MP","limit":"NP","scrollUpAccordion":"OP","wrapper":"PP"};
    if(module.hot) {
      // 1711717534230
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  